import { render, staticRenderFns } from "./SubsidiaryDetails.vue?vue&type=template&id=6ea78aaa&scoped=true"
import script from "./SubsidiaryDetails.vue?vue&type=script&lang=js"
export * from "./SubsidiaryDetails.vue?vue&type=script&lang=js"
import style0 from "./SubsidiaryDetails.vue?vue&type=style&index=0&id=6ea78aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea78aaa",
  null
  
)

export default component.exports